import * as React from 'react';
import {Dispatch, useState} from "react";
import {Modal} from "./Modal";

type PhotoUploadModel = {
    trashesPhotos: any,
    setTrashesPhotos: Dispatch<any>,
    index: number,
    showLoader: string,
    handleNextClick: any,
    selectedCity: string,
    doPhotoAnalyses: any,
    setManualTrashPrice: Dispatch<any>

};

export const PhotoUpload = ({
                                trashesPhotos,
                                setTrashesPhotos,
                                index,
                                showLoader,
                                handleNextClick,
                                selectedCity,
                                doPhotoAnalyses,
                                setManualTrashPrice
                            }: PhotoUploadModel) => {

    const [maxPhotosPerStack, setMaxPhotosPerStack] = useState(3);
    const [latestPhotoIndex, setLatestPhotoIndex] = useState(0);

    const uploadFiles = (event) => {
        setManualTrashPrice('')
        Array.from(event.target.files).forEach(file => {
            const newItem = {
                id: Date.now() + Math.random(),
                url: URL.createObjectURL(file),
                file: file
            };

            setTrashesPhotos(prev => {
                const copy = [...prev];

                if (!copy[index]) {
                    copy[index] = [];
                }

                copy[index] = [...copy[index], newItem];

                return copy;
            });
        });
        doPhotoAnalyses.current?.scrollIntoView({behavior: 'smooth'});
    };

    const doCityValidation = (event) => {
        if (selectedCity === '') {
            event.preventDefault();
            handleNextClick(event);
        }
    }

    const deleteFile = (id) => {
        setManualTrashPrice('')
        setTrashesPhotos(prev => {
            const copy = [...prev];
            copy[index] = copy[index].filter(item => item.id !== id);

            return copy;
        });
    };

    let latestPhoto = trashesPhotos[index]?.[latestPhotoIndex];

    const previewPhoto = (id) => {
        setLatestPhotoIndex(id);
    };

    return (
        <>
            <div className="photo-upload-section" id={"photo-upload-section-" + index}>
                <h3>Atliekų vieta #{index + 1}</h3>
                <p>AI tiksliau įvertins atliekas, jei įkelsite 2–3 nuotraukas.</p>
                <label
                    onClick={doCityValidation}
                    className={trashesPhotos[index] !== undefined && trashesPhotos[index].length > 0 ? "photo-upload normal-border" : "photo-upload"}
                    htmlFor={"photoInput" + index}
                    {...(latestPhoto && {
                        style: {
                            backgroundImage: `url(${latestPhoto.url})`,
                            backgroundSize: `cover`
                        }
                    })}
                >

                    {(trashesPhotos[index] === undefined || trashesPhotos[index].length === 0) && (
                        <label className="upload-empty"
                               htmlFor={"photoInput" + index}>
                            <div>
                                <div className="camera">
                                    <svg className="line-icon upload-line-icon" viewBox="0 0 24 24" fill="none"
                                         aria-hidden="true">
                                        <path d="M12 16V8"></path>
                                        <path d="M9 11l3-3 3 3"></path>
                                        <path d="M4 16.5A2.5 2.5 0 0 0 6.5 19h11A2.5 2.5 0 0 0 20 16.5"></path>
                                    </svg>
                                </div>
                                <h2>Įkelti nuotrauką</h2><p>Spauskite arba vilkite failą čia</p>
                                <div className="file-note">JPG, PNG iki 10 MB</div>
                            </div>
                        </label>
                    )}

                    {(trashesPhotos[index] !== undefined && trashesPhotos[index].length > 0) && (
                        <label className="upload-additional-photo"
                               htmlFor={"photoInput" + index}>
                            <div className="photo-counter"
                                 id="counter">{latestPhotoIndex + 1}/{trashesPhotos[index].length}</div>
                            <div
                                className={trashesPhotos[index].length >= maxPhotosPerStack || showLoader === "show" ? "add-photo hide" : "add-photo"}>+
                                Pridėti dar nuotrauką
                            </div>
                        </label>
                    )}

                    <input type="file" id={"photoInput" + index} multiple accept="image/*"
                           onChange={uploadFiles}
                           disabled={(trashesPhotos[index] && trashesPhotos[index].length >= maxPhotosPerStack) || (selectedCity === '') || showLoader === "show"}/>

                    <div className="analysis-overlay" style={showLoader === "show" ? {display: "block"} : {}}></div>
                </label>
                {(trashesPhotos[index] !== undefined && trashesPhotos[index].length > 0) && (
                    <div className="gallery-head">
                        <h3 id="galleryTitle">{latestPhotoIndex + 1}/{trashesPhotos[index].length} nuotraukos</h3>
                        <p id="pileHelperText" className="pile-helper-text show">Jei atliekos yra kitoje vietoje —
                            pridėkite naują krūvą.</p>
                    </div>)}
                <div className="photo-preview">
                    {(trashesPhotos[index] !== undefined && trashesPhotos[index].length === 0) || trashesPhotos[index] === undefined && (
                        <div className="empty-gallery">Jūsų įkeltos nuotraukos<br/>atsiras čia</div>
                    )}

                    {Array.isArray(trashesPhotos[index]) && trashesPhotos[index].map(function (photo, index) {
                        return <div key={index} className={index === latestPhotoIndex ? "selected thumb" : "thumb"}
                                    onClick={() => previewPhoto(index)}><img
                            src={photo.url} alt=""/>
                            <button type="button" onClick={() => deleteFile(photo.id)}>×</button>
                        </div>
                    })}
                </div>
                <div className="clearfix"></div>
            </div>
        </>
    );
}
